(function () {
  document.querySelectorAll('[data-hscroll-section]').forEach(initSection);

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-hscroll-section]');
      if (section) initSection(section);
    });
  }

  function initSection(section) {
    var track = section.querySelector('[data-hscroll-track]');
    var wrapper = section.querySelector('.hscroll__wrapper');
    if (!track || !wrapper) return;

    var pinned = false;
    var maxTx = 0;
    var rafId = null;

    function measure() {
      maxTx = track.scrollWidth - wrapper.offsetWidth;
      if (maxTx < 0) maxTx = 0;
    }

    function enablePin() {
      if (pinned) return;
      pinned = true;
      section.setAttribute('data-hscroll-pinned', 'true');
      measure();
    }

    function onResize() {
      // Pin on all screen sizes — mobile included
      enablePin();
      measure();
    }

    function onScroll() {
      if (!pinned) return;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    }

    function update() {
      var rect = section.getBoundingClientRect();
      var scrollDist = section.offsetHeight - window.innerHeight;
      if (scrollDist <= 0) return;

      var progress = Math.max(0, Math.min(1, -rect.top / scrollDist));

      var t = progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;

      track.style.transform = 'translate3d(' + -(t * maxTx) + 'px,0,0)';
    }

    onResize();
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });

    var videos = section.querySelectorAll('.hscroll-block__video');
    if (videos.length && 'IntersectionObserver' in window) {
      var vObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.play().catch(function () {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.25 });
      videos.forEach(function (v) { vObs.observe(v); });
    }
  }
})();